export default [
  {
    path: "/operation",
    component: () => import("../pages/operation/OperationPage.vue"),
  },
];
